module.exports = __webpack_public_path__ + "static/media/Frogbutbird.dab16645.jpg";